import Vue from "vue";
import Router from "vue-router";
import { permissionCheck } from "@/utils/router";

const DashboardLayout = () => import("./layouts/Dashboard.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      meta: {},
      component: () =>
        import(/* webpackChunkName: "Auth" */ "./views/Auth.vue"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        auth: true,
        permission: ["superadmin"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Dashboard.vue"),
    },
    {
      path: "/settings/profile",
      name: "editProfile",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ "./views/Profile/Profile.vue"
        ),
    },
    {
      path: "/settings/password",
      name: "editPassword",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ "./views/Profile/Password.vue"
        ),
    },
    {
      path: "/shops",
      name: "shops",
      meta: {
        auth: true,
        permission: ["superadmin"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Shop/landing.vue"),
    },
    {
      path: "/shop/new",
      name: "createShop",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Shop/Shop.vue"),
    },
    {
      path: "/shop/:id",
      name: "editShop",
      meta: {
        auth: true,
        action: "shop/find",
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Shop/Shop.vue"),
    },
    {
      path: "/medias",
      name: "medias",
      meta: {
        auth: true,
        permission: ["superadmin"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Media/landing.vue"),
    },
    {
      path: "/staffs",
      name: "staffs",
      meta: {
        auth: true,
        permission: ["superadmin"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/landing.vue"),
    },
    {
      path: "/users",
      name: "users",
      meta: {
        auth: true,
        permission: ["superadmin", "staff", "customer"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/landing.vue"),
    },
    {
      path: "/user/new",
      name: "createUser",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/User.vue"),
    },
    {
      path: "/staff/new",
      name: "createStaff",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/User.vue"),
    },
    {
      path: "/user/:id/profile",
      name: "editUser",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/User.vue"),
    },
    {
      path: "/user/:id/points",
      name: "userPoints",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/Points.vue"),
    },
    {
      path: "/user/:id/password",
      name: "editUserPassword",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/Password.vue"),
    },
    {
      path: "/user/:id/media",
      name: "editUserMedia",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/Media.vue"),
    },
    {
      path: "/user/:id/logs",
      name: "userLogs",
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/User/Logs.vue"),
    },
    {
      path: "/systemSettings/medicalCondition",
      name: "medicalConditions",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ "./views/SystemSettings/MedicalCondition.vue"
        ),
    },
    {
      path: "/systemSettings/scalpCondition",
      name: "scalpConditions",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ "./views/SystemSettings/ScalpCondition.vue"
        ),
    },
    {
      path: "/systemSettings/MediaTag",
      name: "mediaTags",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ "./views/SystemSettings/MediaTag.vue"
        ),
    },
    {
      path: "/logs",
      name: "logs",
      meta: {
        auth: true,
        permission: ["superadmin", "staff"],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Log/landing.vue"),
    },
    {
      path: "/playground",
      name: "playground",
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ["superadmin"],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "./views/Playground.vue"),
    },
  ],
});

router.beforeEach(permissionCheck);

export default router;
